import React, { useEffect, useState } from "react";
import "./HouseStatus.scss";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import Pagination from "../../utils/Pagination"; 
import { createHouseStatus,deleteHouseStatus,fetchHouseStatusById,fetchHouseStatuses,updateHouseStatus } from "../../services/api";
import AlertMsg from "../../components/AlertMsg/AlertMsg";
import Loading from "../../components/Loading/Loading";
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";

 
const HouseStatusManagement = () => {
  const [houseStatus, setHouseStatus] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); 
  const [isLoading, setIsLoading] = useState(false);
  const [houseToDelete, setHouseToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const housePerPage = 10;
  const [sortAscending, setSortAscending] = useState(true);
  const [formData, setFormData] = useState({
     id:0,
     name: "", 
     activeStatus: true 
    });
    const [errors, setErrors] = useState({
      id:0,
      name: "",
      activeStatus: "",
    });
    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
    const [loading, setLoading] = useState(false);
  // Validation function
  const validateForm = () => {
    let formErrors = { name: "", activeStatus: "" };
    let valid = true;

    if (formData.name.trim() === "") {
      formErrors.name = "House Status name is required";
      valid = false;
    }

    if (formData.activeStatus === null || formData.activeStatus === undefined) {
      formErrors.activeStatus = "Please select a status";
      valid = false;
    }

    setErrors(formErrors);
    return valid;
  };
   const fetchHouseStatus = async () => {
    setLoading(true);
    try {
      const response = await fetchHouseStatuses();
      setHouseStatus(response.data);
    } catch (error) {
      console.error("Error fetching house status data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHouseStatus();
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);

    // Reset form data and errors when closing the modal
    if (isModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
    }
  };


  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);

    // Reset form data and errors when closing the modal
    if (isEditModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
      fetchHouseStatus();
    }
  };

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setHouseToDelete(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "activeStatus" ? value === "true" : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handleSortByName = () => {
    setSortAscending(!sortAscending); // Toggle sorting order
  };
  const filteredHouseStatus = houseStatus
    .filter(
      (block) =>
        block.name && block.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (sortAscending) {
        return a.name.localeCompare(b.name); // Ascending order
      } else {
        return b.name.localeCompare(a.name); // Descending order
      }
    });
  const pageCount = Math.ceil(filteredHouseStatus.length / housePerPage);

  const getCurrentPageHouseStatus = () => {
    const startIndex = currentPage * housePerPage;
    const endIndex = startIndex + housePerPage;
    return filteredHouseStatus.slice(startIndex, endIndex);
  };

  const handleCancel = () => {
    setFormData({
      id: 0,
      name: "",
      activeStatus: true,
    });
    setIsEditModalOpen(false);
    setIsModalOpen(false);
    //setIsEditModalOpen(false);
    setIsDeleteModalOpen(false);
    setHouseToDelete(null);
    setErrors({
      name: "",
      activeStatus: "",
    });
  };

  const handleAddHouseStatus = async () => {
    const isValid = validateForm();
    if (!isValid) return;
    setIsModalOpen(false);
    setLoading(true);

    try {
      const response = await createHouseStatus(formData);
      console.log(response.data);
      setAlert({ visible: true, message: 'House Status added successfully!', type: 'success' });
      handleCancel();
      fetchHouseStatus();
     
    } 
    catch (error) {
      console.error("Error adding house status:", error);
       
      setAlert({ visible: true, message: 'Error adding house status. Please try again.', type: 'error' });
    }
     finally {
      setLoading(false);
    }
  };


  const handleEditHouseStatus = async (id) => {
    setIsEditModalOpen(false);
    console.log(formData)
    try {
      const response = await fetchHouseStatusById(id);
      setFormData(response.data);
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching house status details:", error);
    }
  };

  console.log(formData);

  const handleSaveEditHouseStatus = async () => {
    if (!validateForm()) {
      return;
    }
    setIsEditModalOpen(false);
    setLoading(true);
    try {
      const response = await updateHouseStatus(formData.id,formData)
      console.log(response.data);
      handleCancel();
      fetchHouseStatus();
      setAlert({ visible: true, message: 'House Status updated successfully!', type: 'success' });
    } catch (error) {
      console.error("Error updating house status:", error);
      setAlert({ visible: true, message: 'Error adding house Status. Please try again.', type: 'error' });
     
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteHouseStatus = async () => {
    if (!houseToDelete) return;
    setIsDeleteModalOpen(false);
    setLoading(true);
    try {
      await deleteHouseStatus(houseToDelete.id);
      handleCancel();
      setAlert({ visible: true, message: 'House Status deleted successfully!', type: 'success' });
      fetchHouseStatus();
    } 
      catch (error) {
      console.error("Error deleting house status:", error);
      setAlert({ visible: true, message: 'Error deleting house Status. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteIconClick = (status) => {
    setHouseToDelete(status);
    setIsDeleteModalOpen(true);
  };

  return (
    <div className="houseState">
       {loading && <Loading/>}
      {!loading && (
      <div className="houseState-container box-shadow">
      {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
        <div className="container-head p-15">
          <h2>House Status</h2>
          <div className="btns">
            <span className="add-btn" onClick={toggleModal}>
              <IoIosAddCircleOutline />
              <p>Add Status</p>
            </span>
          </div>
        </div>
        <div className="table-filters">
          <div className="search-filter">
            <label htmlFor="searchName">
              <FaSearch />
            </label>
            <input
              type="text"
              id="searchName"
              placeholder="Search by House Status"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
        <div className="houseState-content" style={{ overflowX: "auto" }}>
          <div className="table-container">
            <table className="custom-table">
              <thead>
                <tr>
                <th onClick={handleSortByName} style={{ cursor: 'pointer' }}>
 House Status {sortAscending ? <RiSortAlphabetAsc /> : <RiSortAlphabetDesc />}
</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {getCurrentPageHouseStatus().length > 0 ? (
                  getCurrentPageHouseStatus().map((item) => (
                    <tr key={item.id}>
                      <td className="text-left">{item.name}</td>
                      <td className="text-center">
                        <p className={
                            item.activeStatus ? "active" : "inactive"
                          }>{item.activeStatus ? "Active" : "Inactive"}</p>
                        
                      </td>
                      <td className="text-center">
                        <div className="action-btn">
      
                          <span
                            className="btn edit-btn"
                            onClick={() => handleEditHouseStatus(item.id)}
                          >
                            <LuFileEdit />
                          </span>
                          <span
                            className="btn delete-btn"
                            onClick={() => handleDeleteIconClick(item)}
                          >
                            <FaRegTrashCan />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3"  className="text-center">No house status found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            pageCount={pageCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
  )}
      {/* Add Modal */}
      {isModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Add House Status</h3>
              <span className="close-icon" onClick={toggleModal}>
                <ImCross />
              </span>
            </div>

            <div className="add-forms">
            <div className={`add-form ${errors.name ? "error" : ""}`}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter House Status"
                  className={errors.name ? "input-error" : ""}
                />
               
              </div>

              <div className="btn-container">
                <div className="addforbtns">
                  <button className="btn-cancel" onClick={toggleModal}>
                    Cancel
                  </button>
                  <button
                    className="btn"
                    onClick={handleAddHouseStatus}
                    disabled={isLoading}
                  >
                    {isLoading ? "Adding..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Edit House Status</h3>
              <span className="close-icon" onClick={toggleEditModal}>
                <ImCross />
              </span>
            </div>

            <div className="add-forms">
              <div className="add-form">
                <label htmlFor="name"> Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter House Status"
                  className={errors.name ? "input-error" : ""}
                />
              </div>
 
              <div className="add-form">
                <label htmlFor="activeStatus">Active Status:</label>
                <div className="custom-radio-group">
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={true}
                      checked={formData.activeStatus === true}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Active
                  </label>
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={false}
                      checked={formData.activeStatus === false}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Inactive
                  </label>
                  {errors.activeStatus && (
                    <span className="error-message">{errors.activeStatus}</span>
                  )}
                </div>
              </div>

              <div className="btn-container">
                <div className="addforbtns">
                  <button className="btn-cancel" onClick={toggleEditModal}>
                    Cancel
                  </button>
                  <button
                    className="btn"
                    onClick={handleSaveEditHouseStatus}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Delete Modal */}
      {isDeleteModalOpen && houseToDelete && (
        <div className="screen">
          <div className="screen-container delete-popup">
          <h2>Are you sure you want to delete?</h2>
          <p>This action is permanent and cannot be undone.</p>

            <button
              onClick={handleDeleteHouseStatus}
              className="delete btn"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Yes, Delete"}
            </button>
            <button className="btn-cancel" onClick={toggleDeleteModal}>
              No, Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HouseStatusManagement;
